export const orderModule = {
    cancel: "취소",
    pay: "지불",
    chose_pay_type:"지불 방식을 선택하세요",
    phone:"휴대폰",
    desc1:"将门票URL发送到以下手机号码或者Email",
    pay_title:"지불",
    to_pay:"지불을하다",
    agree:"동의",
    policy:"개인정보 보호정책",
    total:"합계",
    use_point:"관광 명소를 이용하다",
    use_point_code:"사용할 때 qr 코드를 스캔하세요",
    code:"대조코드",
    used_point:"기용 관광지",
    more:"더 많은",
    input:"필요한 정보를 기입해 주십시오",
    pay_type:"지불 방식을 선택하세요",
    isCancel:"취소하시겠습니까?",
    sure:"확정",
    pay_success:"구매 감사드려요",
    pay_cancel:"성공적으로 취소됨",
    pay_fail:"지불 실패",
    pay_cancel1:"취소됨",
    pay_wait:"지불 결과 대기중",
    status1:"지불을 기다리다",
    status2:"사용할 수 있다",
    status3:"완료",
    status4:"기한이 지났음",
    status5:"환불 완료",
    status6:"취소",
    selectBookFun: "방식을 선택하다",
    inputBookPlaceholder: "영수증의 제명을 입력해 주세요",
    inputMemoPlaceholder: '비고를 적어주세요',
    getBook: "영수증 수취인",
    comment: "논평",
    comment_star: "만족도",
    comment_contentHolder: "평가 글 남겨 주세요",
    comment_noStar: "만족도를 선택하십시오",
    comment_noContent: "평가 내용을 입력하십시오",
    comment_submitSuccess: "평가 성공",
    comment_replay: "가게 댓글",
    comment_uploadSuccess: "업로드 성공",
    comment_moreImg: "최대 4장의 사진 업로드",
    comment_sizeImg: "5m 이상 그려서는 안 된다",
};

export default orderModule;